import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { RouterLink } from '@angular/router'
import { NgStyle } from '@angular/common'

import { BreadcrumbService } from '@shared/services/breadcrumb.service'
import { IconComponent } from '../icons/icons.component'

@Component({
  selector: 'section-title',
  imports: [NgStyle, RouterLink, IconComponent],
  templateUrl: './section-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionTitleComponent {
  color = input.required<string>()

  breadcrumbService = inject(BreadcrumbService)

  pageInfo = computed(() => this.breadcrumbService.pageInfo())
  title = computed(() => this.pageInfo()?.['title'] || '')
  urls = computed(() => this.pageInfo()?.['urls'] || [])

  routerLink = computed(() => {
    const lastUrl = this.urls().at(-2)
    return lastUrl?.url
  })
}
